import React, { useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import { LightBox } from '@lion-design/core';
import * as Tag from '@components/Common/Tag';
import cN from 'classnames';
import styles from './styles.module.scss';

export interface I_Tag {
    TagName: string;
    TagSort: number;
}

export interface I_TripType {
    Name: string;
    Code: string;
}

interface I_Props {
    IsVip?: boolean;
    TripTypeList: I_TripType[];
    TagList: I_Tag[];
    isOnlyMobileHide?: boolean;
    isToggleLightBox?: boolean;
}

const Tags: React.FC<I_Props> = ({
    IsVip = false,
    TripTypeList,
    TagList,
    isOnlyMobileHide = false,
    isToggleLightBox = false,
}) => {
    const [isAllTagsOpen, setIsAllTagsOpen] = useState<boolean>(false);
    const isMobile = useMediaQuery({
        query: '(max-width: 980px)',
    });

    let isHide = false;
    let showTagList = [...TagList];
    const totalLength = TripTypeList.length + TagList.length;

    // 正常情況下 & 總長度超過 8
    if (!isOnlyMobileHide && totalLength > 8) {
        isHide = true;
    }

    // 若只有 M 版才隱藏 & 總長度超過 8 時
    if (isOnlyMobileHide && isMobile && totalLength > 8) {
        isHide = true;
    }

    // 隱藏時，一般標籤 + 旅遊標籤數量最多顯示 8 個
    if (isHide) {
        showTagList = showTagList.splice(0, 8 - TripTypeList.length);
    }

    return totalLength > 0 ? (
        <div className={cN(styles['tag-wrapper'], 'tag-wrapper')}>
            {IsVip && <Tag.Normal text="會員限購" />}
            {TripTypeList?.map((item, i: number) => (
                <Tag.Normal key={i} text={item.Name} tripType={item.Code} />
            ))}
            {showTagList?.map((item, i: number) => (
                <Tag.Normal key={i} text={item.TagName} />
            ))}
            {isHide && (
                <Tag.Normal
                    className={isToggleLightBox ? styles.more : undefined}
                    text="...更多"
                    onClick={isToggleLightBox ? () => setIsAllTagsOpen(true) : undefined}
                />
            )}
            <LightBox
                title="特色標籤"
                className={styles.isAllTags}
                open={isAllTagsOpen}
                ToggleLightBox={() => setIsAllTagsOpen(false)}
            >
                {TripTypeList?.map((item, i: number) => (
                    <Tag.Normal key={i} text={item.Name} tripType={item.Code} />
                ))}
                {TagList?.map((item, i: number) => (
                    <Tag.Normal key={i} text={item.TagName} />
                ))}
            </LightBox>
        </div>
    ) : null;
};

export default Tags;
